import * as React from 'react';
import gettext from '@sdk/lang/gettext';
import Column from '@sdk/components/ui/spacing/Column';
import Text14 from '@sdk/components/ui/typography/Text14';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import type { RestBreakEnabledField, RestBreakThresholdField } from '../types/OrgSettingsFields';
import SettingsSection from '../../../../settings/components/SettingsSection';
import CollapsibleSettingsSection from '../../../../settings/components/CollapsibleSettingsSection';
import SettingsSwitcherRow from '../../../../settings/components/SettingsSwitcherRow';
import RowSpaceBetween from '../../../../settings/components/RowSpaceBetween';
import { FIELD_WIDTH_150 } from '../../../../settings/constants';
import { getRestBreakThresholdHours } from '../../../../settings/components/schedule/helpers/utils';
import { CustomTextField } from '../../components/CustomTextField';

import { useClopening } from './clopening.hooks';

export type Props = {
  restBreakEnabledField: RestBreakEnabledField;
  restBreakThresholdField: RestBreakThresholdField;
};

const Clopening: React.FC<React.PropsWithChildren<Props>> = ({
  restBreakEnabledField,
  restBreakThresholdField,
}) => {
  const { onChangeHandler } = useClopening(restBreakThresholdField);

  return (
    <SettingsSection pBottom={40}>
      <CollapsibleSettingsSection
        isActive={restBreakEnabledField.value}
        headerItem={
          <SettingsSwitcherRow
            title={gettext('Clopening')}
            subtitle={gettext('Prevent clopening cases when scheduling employees.')}
            value={restBreakEnabledField.value}
            onChange={(value: boolean): void => {
              restBreakEnabledField.onChange(value);
              !value && restBreakThresholdField.dirty ? restBreakThresholdField.reset() : null;
            }}
          />
        }
        contentItem={
          <Column pTop={20}>
            <RowSpaceBetween>
              <Column>
                <Text14 themeColor={ThemeColorType.gray}>
                  {gettext(
                    `Define the minimum number of rest hours between
                     the closing shift and the opening shift`
                  )}
                </Text14>
              </Column>

              <CustomTextField
                width={FIELD_WIDTH_150}
                skipErrorMessage
                postfix={gettext('Hours')}
                value={getRestBreakThresholdHours(restBreakThresholdField.value)}
                onChange={(event): void => onChangeHandler(event)}
                onBlur={() => restBreakThresholdField.runValidation(restBreakThresholdField.value)}
                invalid={!!restBreakThresholdField.error}
              />
            </RowSpaceBetween>
          </Column>
        }
      />
    </SettingsSection>
  );
};

export default Clopening;
